/**
 * [$ description] 工具类
 * @type {[type]}
 * Created by Ms.du on 2018/5/12.
 */
var tool = {
  /**
     * [isJSON description] 是否为json
     * @param  {[type]}  obj [description]
     * @return {Boolean}     [description]
     */
  isJSON(obj) {
    return typeof obj === 'object' && Object.prototype.toString.call(obj).toLowerCase() === '[object object]' &&
            !obj.length
  },
  /**
     * [stringify description] 序列化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
  stringify(val) {
    return val === undefined || typeof val === 'function' ? val + '' : JSON.stringify(val)
  },
  isPhone(value) {
    return /^1\d{10}$/.test(value)
  },
  /**
     * [deserialize description] 反序列化
     * @return {[type]} [description]
     */
  deserialize(value) {
    if (typeof value !== 'string') {
      return undefined
    }
    try {
      return JSON.parse(value)
    } catch (e) {
      return value || undefined
    }
  },
  /**
     * [isFunction description] 是否为func
     * @return {Boolean} [description]
     */
  isFunction(value) {
    return {}.toString.call(value) === '[object Function]'
  },
  /**
     * [isArray description] 是否为数组
     * @return {Boolean} [description]
     */
  isArray(value) {
    return value instanceof Array
  },
  /**
     * [islocalStorage description] 浏览器是否支持localStorage
     * @return {[type]} [description]
     */
  islocalStorage() {
    return !!window.localStorage
  },
  /**
     * 验证验证码个数
     */
  isCode(value) {
    return /^\d{6}$/.test(value)
  },
  /**
     * [setStore description] 设置 localStorage
     * @param  {[type]} key  [description]
     * @param  {[type]} value [description]  --->  单个  数组  {}
     * @return {[type]}       [description]
     */
  setStore(key, value) {
    if (this.islocalStorage) {
      if (key && !this.isJSON(key)) {
        window.localStorage.setItem(key, this.stringify(value))
      } else if (key && this.isJSON(key) && !value) {
        for (const a in key) this.setStore(a, key[a])
      }
    } else {
      console.log('浏览器不支持localStorage(setStore)')
    }
  },
  /**
     * [getStore description] 获取某个localStorage值
     * @param  {[type]} name [description]
     * @return {[type]}      [description]
     */
  getStore(key) {
    if (this.islocalStorage) {
      if (!key) {
        throw new Error('getStore参数不存在')
      }
      return this.deserialize(window.localStorage.getItem(key))
    } else {
      console.log('浏览器不支持localStorage(getStore)')
    }
  },
  /**
     * [delStore description] 删除某个 localStorage值
     * @param  {[type]} key [description]
     * @return {[type]}     [description]
     */
  delStore(key) {
    if (this.islocalStorage) {
      if (!key) {
        throw new Error('delStore参数不存在')
      }
      window.localStorage.removeItem(key)
    } else {
      console.log('浏览器不支持localStorage(getStore)')
    }
  },
  /**
     * [clearStore description] 清空localStorage
     * @return {[type]} [description]
     */
  clearStore() {
    if (this.islocalStorage) {
      window.localStorage.clear()
    } else {
      console.log('浏览器不支持localStorage(clearStore)')
    }
  },
  getCookie(name) {
    var arr; var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    if (arr = document.cookie.match(reg)) { return unescape(arr[2]) } else { return null }
  },
  formateYYYYMMDD(date) {
    var newData
    if (date) {
      newData = new Date(date)
    } else {
      newData = new Date()
    }
    var year = newData.getFullYear()
    var month = newData.getMonth() + 1
    var dd = newData.getDate()
    var hh = newData.getHours()
    var mm = newData.getMinutes()
    var ss = newData.getSeconds()
    if (dd.toString().length == 1) {
      dd = '0' + dd
    }
    if (hh.toString().length == 1) {
		    hh = '0' + hh
    }
    if (mm.toString().length == 1) {
      mm = '0' + mm
    }
    if (ss.toString().length == 1) {
		    ss = '0' + ss
    }
    return year + '-' + month + '-' + dd + ' ' + hh + ':' + mm + ':' + ss
  },
  formateYYYYmmdd(date) {
	    var newData
	    if (date) {
	        newData = new Date(date)
	    } else {
	        newData = new Date()
	    }
	    var year = newData.getFullYear()
	    var month = newData.getMonth() + 1
	    var dd = newData.getDate()
	    var hh = newData.getHours()
	    var mm = newData.getMinutes()
       var ss = newData.getSeconds()
        if(month.toString().length == 1){
          month = '0' + month
        }
	    if (dd.toString().length == 1) {
	        dd = '0' + dd
	    }
    if (hh.toString().length == 1) {
		    hh = '0' + hh
    }
	    if (mm.toString().length == 1) {
	        mm = '0' + mm
	    }
    if (ss.toString().length == 1) {
		    ss = '0' + ss
    }
	    return year + '-' + month + '-' + dd + ' ' + hh + ':' + mm
  },
  formateDate(date) {
    var newData
    if (date) {
      newData = new Date(date)
    } else {
      newData = new Date()
    }
    var year = newData.getFullYear()
    var month = newData.getMonth() + 1
    var dd = newData.getDate()
    if (month.toString().length == 1) {
      month = '0' + month
    }
    if (dd.toString().length == 1) {
      dd = '0' + dd
    }
    return year + '-' + month + '-' + dd
  },
  formateYYYYMM(date) {
	    var newData
	    if (date) {
	        newData = new Date(date)
	    } else {
	        newData = new Date()
	    }
	    var year = newData.getFullYear()
	    var month = newData.getMonth() + 1
	    var dd = newData.getDate()
	    if (month.toString().length == 1) {
	        month = '0' + month
	    }
	    if (dd.toString().length == 1) {
	        dd = '0' + dd
	    }
	    return year + '-' + month
  },
  formateDateNoDelimiter(date) {
    var newData = new Date(date)
    var year = newData.getFullYear()
    var month = newData.getMonth() + 1
    var dd = newData.getDate()
    if (month.toString().length == 1) {
      month = '0' + month
    }
    if (dd.toString().length == 1) {
      dd = '0' + dd
    }
    return year + month + dd
  },
  point(params) {
    params = params.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
    params = params.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
    params = params.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    params = params.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
    if (params.indexOf('.') < 0 && params != '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
      params = parseFloat(params)
    }
    return params
  },
  setHead(head) {
    if (head) {
      return head.indexOf('qlogo') == -1 ? (BaseUrl.ImgHead + head) : head
    }
  },
  // 计算2个时间差
  datedifference(sDate1, sDate2) { // sDate1和sDate2是2006-12-18格式
    var dateSpan,
      tempDate,
      iDays
    sDate1 = Date.parse(sDate1)
    sDate2 = Date.parse(sDate2)
    dateSpan = sDate2 - sDate1
    dateSpan = Math.abs(dateSpan)
    iDays = Math.floor(dateSpan / (24 * 3600 * 1000))
    return iDays
  },
  // 拼接提醒时间 time年月  time2 小时分
  addCustTime(time, time2) {
    var date = new Date(tool.formateDate(time))
    date = date.setHours(time2.substr(0, 2), time2.substr(3, 4))
    return new Date(date).getTime()
  },
  // 获取显示时间
  timeAgo(dateTimeStamp) {
    var minute = 1000 * 60 // 把分，时，天，周，半个月，一个月用毫秒表示
    var hour = minute * 60
    var day = hour * 24
    var week = day * 7
    var halfamonth = day * 15
    var month = day * 30
    var now = new Date().getTime() // 获取当前时间毫秒
    console.log(now)
    var result = ''
    var diffValue = now - dateTimeStamp // 时间差

    if (diffValue < 0) {
      return
    }
    var minC = diffValue / minute // 计算时间差的分，时，天，周，月
    var hourC = diffValue / hour
    var dayC = diffValue / day
    var weekC = diffValue / week
    var monthC = diffValue / month
    if (monthC >= 1 && monthC <= 3) {
      result = ' ' + parseInt(monthC) + '月前'
    } else if (weekC >= 1 && weekC <= 3) {
      result = ' ' + parseInt(weekC) + '周前'
    } else if (dayC >= 1 && dayC <= 6) {
      result = ' ' + parseInt(dayC) + '天前'
    } else if (hourC >= 1 && hourC <= 24) {
      result = ' ' + parseInt(hourC) + '小时前'
    } else if (minC >= 1 && minC <= 59) {
      result = ' ' + parseInt(minC) + '分钟前'
    } else if (diffValue >= 0 && diffValue <= minute) {
      result = '刚刚'
    } else {
      var datetime = new Date()
      datetime.setTime(dateTimeStamp)
      var Nyear = datetime.getFullYear()
      var Nmonth = datetime.getMonth() + 1 < 10 ? '0' + (datetime.getMonth() + 1) : datetime.getMonth() + 1
      var Ndate = datetime.getDate() < 10 ? '0' + datetime.getDate() : datetime.getDate()
      var Nhour = datetime.getHours() < 10 ? '0' + datetime.getHours() : datetime.getHours()
      var Nminute = datetime.getMinutes() < 10 ? '0' + datetime.getMinutes() : datetime.getMinutes()
      var Nsecond = datetime.getSeconds() < 10 ? '0' + datetime.getSeconds() : datetime.getSeconds()
      result = Nyear + '-' + Nmonth + '-' + Ndate
    }
    console.log(result)
    return result
  },
  formateYYYYMMDD(date) {
    var newData
    if (date) {
      newData = new Date(date)
    } else {
      newData = new Date()
    }
    var year = newData.getFullYear()
    var month = newData.getMonth() + 1
    var dd = newData.getDate()
    var hh = newData.getHours()
    var mm = newData.getMinutes()
  	var ss = newData.getSeconds()
    if (dd.toString().length == 1) {
      dd = '0' + dd
    }
  	if (hh.toString().length == 1) {
  	    hh = '0' + hh
  	}
    if (mm.toString().length == 1) {
      mm = '0' + mm
    }
  	if (ss.toString().length == 1) {
  	    ss = '0' + ss
  	}
    return year + '-' + month + '-' + dd + ' ' + hh + ':' + mm + ':' + ss
  }
}
export default tool
